module.exports = __webpack_public_path__ + "img/photo-0137.91cbd651.jpg";